module.exports = __webpack_public_path__ + "media/images/map_icons/Soccer-de1dd35131bf408951f0c3bb8b20abfb.svg";